import * as monaco from 'monaco-editor'
import axios from 'axios';

export default {
    get exampleCode() {
        return `#include <iostream>
using namespace std;
int main() {
    int a = 123;
    cout << a*10 << endl;
    return 0;
}`;
    },

    configure (runtimeConfig) {
        this.compilationBackend = runtimeConfig.compilationBackend;
    },

    async run (terminalBus, editor, code, showSuccess) {
        terminalBus.$emit('writeMessage', 'Compiling...\n\n');
        terminalBus.$emit('writeMessage', '\n');
        let response;
        try {
            response = await axios.post(`${this.compilationBackend}/compile`, { code });
        } catch (err) {
            terminalBus.$emit('writeMessage', '\x1B[1;3;31mCompilation error!\x1B[0m\n');
            terminalBus.$emit('writeMessage', `\x1B[1;3;31m${err.response.data.stderr}\x1B[0m\n`);
            
            const regex = /^program\.cpp:(\d+):(\d+).+?error: (.*?)$/gm;
            const markers = [];

            let match;
            while (match = regex.exec(err.response.data.stderr)) {
                markers.push({
                    startLineNumber: match[1],
                    startColumn: match[2],
                    endColumn: this.getLine(code, match[1]).length,
                    endLineNumber: match[1],
                    message: match[3],
                    severity: 3
                });
            }

            monaco.editor.setModelMarkers(
                editor.getModel(),
                null,
                markers
            );
            
            return;
        }

        const buildProgram = eval(`(terminalBus) => {
            var Module = { 
                noInitialRun: true,
                print: text => terminalBus.$emit('writeOutput', \`\${text}\\n\`),
                printErr: text => terminalBus.$emit('writeOutput', \`\\x1B[1;3;31m\${text}\\x1B[0m\\n\`)
            };
            ${response.data};

            return Module;
        }`);
        const Module = buildProgram(terminalBus);
        Module.callMain();
    },
    getLine (code, number) {
        return code.split('\n')[number - 1]
    },
    async test (code, tests = [], inputs = []) {
        let response;

        try {
            response = await axios.post(`${this.compilationBackend}/compile-tests`, { code, tests: tests.map(test => ({ code: test.code, valueGenerator: test.valueGenerator })) });
        } catch (err) {
            if (err.response.status === 400) {
                return tests.map((test) => ({...test, result: false}));
            } else {
                throw 'Server error';
            }
        }

        const buildProgram = eval(`(generatorPrint) => {
            var Module = { 
                noInitialRun: true,
                print: text => generatorPrint(text),
            };
            ${response.data};

            return Module;
        }`);
        let stringBuffer = '';
        function generatorPrint(text) {
            stringBuffer = text;
        }
        const Module = buildProgram(generatorPrint);

        return tests.map((test, num) => ({
            ...test, 
            result: Module.ccall(`test_${num}`), 
            generatedValue: (() => { Module.ccall(`generator_${num}`); return stringBuffer; })()
        }));
        
    }
}
